import React, { useEffect, useRef } from 'react';

/*
This hooks works as a useEffect but don't trigger at first render of the component
*/
const useAfterMountEffect = (func, deps) => {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) func();
        didMount.current = true;
    }, deps);
};

export default useAfterMountEffect;
